import React, {ReactNode, useCallback, useState} from 'react';
import {Link} from 'react-router-dom';

import {GeneralAlert} from 'src/openapi/admin/models/GeneralAlert';

import EllipsisTextHint from '@pb/kit-component-ellipsis-text-hint';
import {Integer} from '@pb/kit-component-formatters';
import Loading from '@pb/kit-component-loading';
import {Cell, Row} from '@pb/kit-component-table';

import {getGeneralAlertItemType} from '../utils/util';

import {AlertDetailsModal} from './alert-details-modal';

type Props = {
    showZebra: boolean,
    contentId: string,
    alert: GeneralAlert,
    frequencyDescription: string,
    searchTypeDescription: string,
    alertCount: number,
    userId: number,
    isAlertCountLoading: boolean,
};

export const SavedAlertTableRow = (props: Props) => {
    const {showZebra,
        contentId,
        alert,
        frequencyDescription,
        searchTypeDescription,
        alertCount,
        userId,
        isAlertCountLoading,
    } = props;
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = useCallback(() => setIsModalOpen(true), []);
    const closeModal = useCallback(() => setIsModalOpen(false), []);

    const alertCountContent: ReactNode = isAlertCountLoading ? <Loading type="ICON"/> : <Integer value={alertCount}/>;

    return (
        <Row showZebra={showZebra} key={contentId}>
            <Cell>
                <Link to="#" onClick={openModal}>
                    <EllipsisTextHint title={alert.alertTitle}>{alert.alertTitle}</EllipsisTextHint>
                </Link>
                {isModalOpen ? (
                    <AlertDetailsModal
                        contentId={alert.contentId}
                        alertTypeCode={alert.searchListType}
                        title={alert.alertTitle}
                        isOpen={isModalOpen}
                        onClose={closeModal}
                        userId={userId}
                    />
                ) : null}
            </Cell>
            <Cell>{getGeneralAlertItemType(alert.generalAlertType)}</Cell>
            <Cell>{searchTypeDescription}</Cell>
            <Cell>General</Cell>
            <Cell>{frequencyDescription}</Cell>
            <Cell>{alertCountContent}</Cell>
        </Row>
    );
};
